import React, { memo } from 'react'
import InfoIcon from 'transfix-icons/build/InfoIcon'
import { ITooltipProps, Tooltip } from 'transfix-ui/components/Tooltip'
import { makeStyles } from 'transfix-ui/core'
import { brandColors, theme } from 'transfix-ui/theme'
import { TEST_IDS } from '../../../../constants'

export const useCarrierInfoTooltipStyles = makeStyles(() => ({
  infoIcon: {
    marginLeft: theme.spacing(0.5),
    color: brandColors.coolGray5,
  },
}))

const IN_REVIEW_TOOLTIP =
  'You requested approval to manage this carrier. An email was sent to the carrier’s Admin to approve you.'

export interface ICarrierInfoTooltipProps extends Omit<ITooltipProps, 'trigger' | 'position'> {}

const CarrierInfoTooltip = memo<ICarrierInfoTooltipProps>(({ ...rest }) => {
  const classes = useCarrierInfoTooltipStyles()
  return (
    <Tooltip
      trigger={<InfoIcon className={classes.infoIcon} data-test={TEST_IDS.infoTooltip} />}
      position='bottom'
      {...rest}>
      {IN_REVIEW_TOOLTIP}
    </Tooltip>
  )
})

export default CarrierInfoTooltip
